module.exports = __webpack_public_path__ + "media/LandingPageAssets/macrosImages-8d5e2ed3.png";